import { Box, ImageLabel, Typography } from '@wishket/design-system';
import dynamic from 'next/dynamic';

const AiLabel = dynamic(() =>
  import('./PageTitle.parts').then((mod) => mod.AiLabel)
);

interface PageTitleProps {
  title: string;
  subTitle?: string;
  isNew?: boolean;
  isAi?: boolean;
}

const PageTitle = ({ title, subTitle, isNew, isAi }: PageTitleProps) => {
  return (
    <Box className="flex flex-col gap-1 desktop:gap-2">
      <Box className="flex gap-1.5">
        <h1 className="font-medium text-w-gray-900 typo-subTitle1 desktop:typo-title3">
          {title}
        </h1>
        {isNew && (
          <Box className="pt-1.5" data-testid="new-label">
            <ImageLabel type="new_circle" />
          </Box>
        )}
        {isAi && <AiLabel />}
      </Box>
      {subTitle && (
        <Typography variant="body1" className="text-w-gray-600">
          {subTitle}
        </Typography>
      )}
    </Box>
  );
};

export default PageTitle;
